import {Component} from '@angular/core';
import { Localization } from '../../common/enums/localization';

@Component({
  selector: 'app-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss'],
})
export class ActionsComponent {
  public readonly Localization = Localization;
}
